module.exports = {
      id: "tumblr-usage",
      viewBox: "0 0 40 64",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#tumblr",
      toString: function () {
        return this.url;
      }
    }